import { Typography, styled } from '@mui/material';
import { FC } from 'react';

const StyledTitle = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(3),
  backgroundColor: theme.palette.secondary.light,
  fontSize: '14pt',
  color: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

type ModalHeaderProps = {
  icon?: JSX.Element;
  title: string;
};
const ModalHeader: FC<ModalHeaderProps> = ({ icon, title }) => {
  return (
    <StyledTitle variant="h3">
      {icon}
      {title}
    </StyledTitle>
  );
};
export { ModalHeader };
